(() => {
  if (window.nickProductMobileSafetyLoaded) return;
  window.nickProductMobileSafetyLoaded = true;

  const root = document.documentElement;
  const mobile = window.matchMedia('(max-width: 749px)');
  let frame = 0;
  let sticky = null;
  let resizeObserver = null;
  let stateObserver = null;
  let discoveryObserver = null;

  const update = () => {
    frame = 0;
    const shown = sticky && mobile.matches &&
      (sticky.classList.contains('show') || sticky.classList.contains('always-visible'));
    const style = sticky ? window.getComputedStyle(sticky) : null;
    const mobileBar = sticky?.querySelector('.sticky-atc-mobile');
    const bottomPosition = sticky?.dataset.mobilePosition === 'bottom';
    const visible = Boolean(shown && bottomPosition && style.display !== 'none' &&
      style.visibility !== 'hidden' && mobileBar && mobileBar.getBoundingClientRect().height > 0);

    root.classList.toggle('nick-mobile-cart-visible', visible);
    if (visible) {
      const height = sticky.getBoundingClientRect().height;
      const bottom = Math.max(0, Number.parseFloat(style.bottom) || 0);
      root.style.setProperty('--nick-mobile-cart-clearance', `${Math.ceil(height + bottom + 12)}px`);
    } else {
      root.style.removeProperty('--nick-mobile-cart-clearance');
    }
  };

  const schedule = () => {
    if (!frame) frame = window.requestAnimationFrame(update);
  };

  const connect = () => {
    resizeObserver?.disconnect();
    stateObserver?.disconnect();
    discoveryObserver?.disconnect();
    sticky?.removeEventListener('transitionend', schedule);
    sticky = document.querySelector('.sticky-atc');
    root.classList.add('nick-mobile-product-safety');
    if (!sticky) {
      discoveryObserver = new MutationObserver(() => {
        if (document.querySelector('.sticky-atc')) connect();
      });
      discoveryObserver.observe(document.body, { childList: true, subtree: true });
      schedule();
      return;
    }
    resizeObserver = new ResizeObserver(schedule);
    resizeObserver.observe(sticky);
    stateObserver = new MutationObserver(schedule);
    stateObserver.observe(sticky, { attributes: true, attributeFilter: ['class', 'style', 'data-mobile-position'] });
    sticky.addEventListener('transitionend', schedule);
    schedule();
  };

  mobile.addEventListener('change', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', connect);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', connect, { once: true });
  } else {
    connect();
  }
})();
